import ConfirmationError from './ConfirmationError';

export default ConfirmationError;
